// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3aKPz","search":"Settings_search__eKAZm","filter":"Settings_filter__1PzlL"};